export default __webpack_public_path__ + "static/media/level_2.53fbee95.png";